import { PlusCircleIcon } from '@heroicons/react/24/outline';
import HeaderLogo from '../constants/HeaderLogo';

export default function Header({ title, publicId }) {
  return (
    <header className="bg-white shadow sm:ml-64">
      <div className="mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <HeaderLogo publicId={publicId} />
        {title && (
          <div className="flex flex-row">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">
              {title}
            </h1>
          </div>
        )}
      </div>
    </header>
  );
}
